import { type OrderConfirmation } from "./types";

export const DUMMY_ORDER: OrderConfirmation.OrderSummary = {
  attributes: [],
  billingReferences: [],
  history: [],
  order: {
    orderId: "dummy",
    billingAddressId: null,
    billingCity: "dummy",
    billingCompany: "dummy",
    billingCompanyTaxNumber: "dummy",
    billingEmail: "dummy",
    billingFirstName: "dummy",
    billingCountryCode: "US",
    billingCountryName: "dummy",
    billingSubdivisionCode: "",
    billingSubdivisionName: "dummy",
    billingLastName: "dummy",
    billingPostalCode: "dummy",
    billingStreet: "dummy",
    billingTelephone: "dummy",
    billingUnit: "dummy",
    eventDateLocationName: "dummy",
    eventName: "dummy",
    eventOpenDate: null,
    currencyCode: "USD",
    isSameAsShipping: true,
    minOrderShippingStatusKey: "dummy",
    minOrderShippingStatusName: "dummy",
    minOrderStatusKey: "dummy",
    minOrderStatusName: "dummy",
    number: 1000,
    orderedOnDate: new Date().toISOString(),
    orderPaymentStatusName: "dummy",
    paymentMethodName: "dummy",
    shippingAddressId: null,
    shippingCity: "dummy",
    shippingCompany: "dummy",
    shippingCompanyTaxNumber: "dummy",
    shippingEmail: "dummy",
    shippingFirstName: "dummy",
    shippingCountryCode: "US",
    shippingCountryName: "dummy",
    shippingSubdivisionCode: "",
    shippingSubdivisionName: "dummy",
    shippingLastName: "dummy",
    shippingPostalCode: "dummy",
    shippingStreet: "dummy",
    shippingTelephone: "dummy",
    shippingUnit: "dummy",
    shippingPickupPointCode: "dummy",
    shippingLatitude: null,
    shippingLongitude: null
  },
  orderItems: [
    {
      availableQuantity: 10,
      children: [],
      description: "Dummy",
      eventIsAvailable: true,
      id: "dummy",
      imageUrl: null,
      name: "Dummy",
      originalPrice: 0,
      permalink: null,
      price: 1,
      productId: null,
      quantity: 1,
      requiresShipping: true,
      subname: "Dummy",
      subscriptionInfo: null,
      taxPercentage: 0,
      warehouseShippingCode: null
    }
  ],
  totals: {
    discountAmount: 0,
    dueAmount: 0,
    paidAmount: 0,
    shippingAmount: 0,
    subtotalAmount: 0,
    surcharges: [],
    taxAmount: 0,
    taxTotalAmount: 0,
    totalAmount: 0,
    voucherAmount: 0
  }
};

export const isDummyOrder = (id: string) => DUMMY_ORDER.order.orderId === id;
